
<template>
    <div>
        <vs-dialog v-model="active" prevent-close width="750px">
            <template #header>
                <h4 class="not-margin">
                    Editar estatus de beca
                </h4>
            </template>

            <div class="con-form">
                <vs-row>
                    <vs-col class="inputTitulo" sm="12" lg="6">
                        <label>Estatus</label>
                        <vs-select
                            class="pt-0"
                            placeholder="Becas" 
                            v-model="estatus"
                        >
                            <vs-option label="Activa" value="1">
                                Activa
                            </vs-option>
                            <vs-option label="Inactiva" value="2">
                                Inactiva
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col class="inputTitulo" sm="12" lg="6">
                        <label class="pl-0">Comentario</label>
                        <div>
                            <textarea v-model="comentario" rows="2"></textarea>
                        </div>
                    </vs-col>
                </vs-row>
            </div>
            <div class="d-flex mt-4">
                <div @click="active = false">
                    <div class="botonCancelar">
                        Cancelar
                    </div>
                </div>
                <vs-button
                    success
                    class="ml-auto"
                    @click="postEditarBeca()"
                >
                    Guardar
                </vs-button>
            </div>
        </vs-dialog>
    </div>  
</template>
<script>
import alumnos from '../../../../../../api/requests/alumno'
export default {
    props:[
      'value',
      'general',
      'csrf_token',
      'selectBeca',
      'institucion_id_url'
    ],
    data(){
        return{
            active: false,
            estatus: '',
            comentario: ''
        }
    },
    methods:{
        getInfo(){
            this.estatus= this.selectBeca.status == 'activa' ? '1' : '2'
            this.comentario = this.selectBeca.comentario
        },
        async postEditarBeca(){
            const loading = this.$vs.loading()
            try{
                
                const formData = new FormData()
                formData.append('status', this.estatus == '1' ? 'activa' : 'inactiva')
                formData.append('comentario', this.comentario)
                formData.append('_token', this.csrf_token)
                formData.append('institicion_id', this.institucion_id_url)
                const {data: response} = await alumnos.postEditarBeca(this.selectBeca.id, formData)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: 'Se ha editado con éxito la beca.'
                })
                loading.close()
                this.$emit('refreshTableBeca')
                this.active = false
            }catch(error){
                console.log(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    duration: 5000,
                    position: null,
                    title: 'Algo salío mal',
                    text: 'Favor de comunicarse con el administrador'
                })
                loading.close()
                this.active = false
            }
        }
    },
    watch:{
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        selectBeca(){
            this.getInfo()
        }
    }
}
</script>
<style scoped>
textarea{
    width: 100%;
}
</style>